import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { RequireLoggedInUserAuthGuard, RequireLoggedOutUserAuthGuard } from '../guards/auth.guard';
import { ConversationRouteResolverService } from './conversation-route-resolver.service';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/tabs/conversations', // TODO: TXBDEV-2338 - Refactor the routes to make sense.
    pathMatch: 'full'
  },
  {
    path: 'tabs',
    loadChildren: () => import('../pages/tabs/tabs.module').then(m => m.TabsPageModule),
    canLoad: [RequireLoggedInUserAuthGuard]
  },
  {
    path: 'new-conversation', // TODO: TXBDEV-2338 - Refactor the routes to make sense.
    loadChildren: () => import('../pages/new-conversation/new-conversation.module').then(m => m.NewConversationPageModule),
    canLoad: [RequireLoggedInUserAuthGuard]
  },
  {
    path: 'canned-responses',
    loadChildren: () => import('../pages/canned-responses/canned-responses.module').then(m => m.CannedResponsesPageModule),
    canLoad: [RequireLoggedInUserAuthGuard]
  },
  {
    path: 'canned-response/:id',
    loadChildren: () => import('../pages/canned-response/canned-response.module').then(m => m.CannedResponsePageModule),
    canLoad: [RequireLoggedInUserAuthGuard]
  },
  { 
    path: 'add-canned-response', 
    loadChildren: () => import('../pages/canned-response/canned-response.module').then(m => m.CannedResponsePageModule),
    canLoad: [RequireLoggedInUserAuthGuard]
  },
  {
    path: 'conversations', // TODO: TXBDEV-2338 - Refactor the routes to make sense.
    loadChildren: () => import('../pages/tabs/pages/conversation/conversation.module').then(m => m.ConversationPageModule),
    canLoad:  [RequireLoggedInUserAuthGuard],
  },
  {//MOVED CONTACTS ROUTE HERE TO REMOVE TAB BAR. PAGES MOVING FORWARD A TAB STACK SHOULD NOT SHOW THE TAB BAR. SIMILAR TO CONVERSATIONS ^.
    // USER IS PRONE TO HAVING A BAD EXPERIENCE WITH THE BACK BUTTON. (LOOP STUCK)
    path: 'contacts/:id',
    loadChildren: () => import('../pages/tabs/pages/contact/contact.module').then( m => m.ContactPageModule),
    canLoad: [RequireLoggedInUserAuthGuard]
  },
  {
    path: 'login',
    loadChildren: () => import('../pages/login/login.module').then( m => m.LoginPageModule),
    canLoad: [RequireLoggedOutUserAuthGuard]
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('../pages/forgot-password/forgot-password.module').then( m => m.ForgotPasswordPageModule)
  },
  {
    path: 'add-contact',
    loadChildren: () => import('../pages/add-contact/add-contact.module').then( m => m.AddContactPageModule),
    canLoad: [RequireLoggedInUserAuthGuard]
  },
  {
    path: 'ios-message-popover',
    loadChildren: () => import('../pages/ios-message-popover/ios-message-popover.module').then( m => m.IosMessagePopoverPageModule),
    canLoad: [RequireLoggedInUserAuthGuard]
  },
  {
    path: 'edit-scheduled-message-modal',
    loadChildren: () => import('../pages/edit-scheduled-message-modal/edit-scheduled-message-modal.module').then( m => m.EditScheduledMessageModalPageModule),
    canLoad: [RequireLoggedInUserAuthGuard]
  },
  {
    path: 'import-contacts',
    loadChildren: () => import('../pages/import-contacts/import-contacts.module').then( m => m.ImportContactsPageModule),
    canLoad: [RequireLoggedInUserAuthGuard]
  },
  {
    path: 'import-contacts-modal',
    loadChildren: () => import('../pages/import-contacts-modal/import-contacts-modal.module').then( m => m.ImportContactsModalPageModule),
    canActivate: [RequireLoggedInUserAuthGuard]
  },
  {
    path: 'note-modal',
    loadChildren: () => import('../pages/note-modal/note-modal.module').then( m => m.NoteModalPageModule),
    canLoad: [RequireLoggedInUserAuthGuard]
  },
  {
    path: 'user-signature',
    loadChildren: () => import('../pages/user-signature/user-signature.module').then( m => m.UserSignaturePageModule),
    canLoad: [RequireLoggedInUserAuthGuard]
  }
];
@NgModule({
  imports: [
  RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
